<script setup lang="ts">
import type { Topic } from '~/api/types';

const props = defineProps<{ topic: Topic }>();
</script>

<template>
  <nuxt-link
    :to="`/topics/${props.topic.slug}`"
    class="topic-card"
  >
    <div class="topic-card__content">
      <h5 class="topic-card__content__title">
        {{ props.topic.title }}
      </h5>
      <p class="topic-card__content__description">
        {{ props.topic.description }}
      </p>
    </div>
  </nuxt-link>
</template>

<style scoped lang="scss">
.topic-card {
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  border-radius: 12px;
  background: white;

  &:hover {
    background: $background-button-secondary-hover;
    transform: translateY(-2px);
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 4px;

    &__title {
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 26px;
      color: $foreground-contrast;
      margin: 0;
    }

    &__description {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      color: $foreground-gray;
    }
  }
}
</style>
